import axios from "axios";
import localStorageService from "./LocalStorageService";


const apiRequest = async (method, url = "", data = null, contentType="application/json",config = {},) => {
  try {
    const customAxios = axios.create({
      baseURL: process.env.REACT_APP_BASE_URL,
      headers: {
        "Content-Type":contentType,
        Authorization: `Bearer ${localStorageService.getItem("token")}`,
      },
    });

    url = decodeURIComponent(url);

    const response = await customAxios({
      method,
      url,
      data,
      responseType:config.responseType || "json",
      ...config,
    });
    return response?.data;
  } catch (error) {
    console.log("error",error.response)
    if (
      error?.response?.status === 401 ||
      error?.response?.data?.message === "Invalid credentials"
    ) {
      localStorageService.clearStorage();
      window.location.reload();
    }
    console.error("API Error:", error);
    throw error || new Error("API Error");
  }
};

export default apiRequest;
